import { SearchInput } from "@/components/atoms";
import { useGetInvoicesCompaniesParams } from "../hooks";

export const InvoicesCompaniesSearch = () => {
  const { search, setSearch } = useGetInvoicesCompaniesParams();

  return <SearchInput search={search} onSearch={(value) => setSearch(value)} placeholder="Search..." size="md" />;
};
